<!-- OFFERTE -->

<div class="form-title">
  <div class="d-flex fixed-header-height">
    <div class="form-title-text">Offerte</div>
    <div class="d-flex placers-space" *ngIf="subproject.quotationHandler">
      <div
        class="employee-initials rounded-circle in-the-middle"
        [matTooltip]="getName(subproject.quotationHandler)"
      >
        <span *ngIf="!subproject.quotationHandler.user?.profilePicture">
          {{ getLetters(subproject.quotationHandler) }}
        </span>
        <span *ngIf="subproject.quotationHandler.user?.profilePicture">
          <img
            class="rounded-circle"
            width="30px"
            height="30px"
            [src]="
              '/api/assets/' +
              subproject.quotationHandler.user.profilePicture.uuid +
              '/30'
            "
          />
        </span>
      </div>
    </div>
    <mat-icon
      *ngIf="subproject.quotation?.approved"
      class="medium-icon placers-space align-with-title"
      svgIcon="check"
    >
    </mat-icon>
    <p
      *ngIf="subproject.quotation?.approvalRegistration"
      class="placers-space align-date"
    >
      Akkoord:
      {{ formatDate(subproject.quotation.approvalRegistration.date) }}
    </p>
  </div>
</div>

<yes-no
  [title]="'Offerte nodig'"
  [extraInstructions]="'Info omtrent offerte en opvolgen'"
  [nullIsFalse]="false"
  [alwaysShowExtraInstructions]="true"
  [value]="subproject.needsQuotation"
  [inputText]="subproject.quotationComments"
  [nullable]="true"
  (answer)="needsQuotation($event)"
  (answeredText)="needsQuotationText($event)"
></yes-no>

<mat-card
  *ngIf="subproject.needsQuotation"
  class="top-card mat-elevation-z0 overflowHidden details-margin"
>
  <div
    *ngIf="subproject.needsQuotation"
    [class.collapsed]="quotationIsCollapsed"
    class="section-header d-flex overflowHidden clickable"
    (click)="quotationIsCollapsed = !quotationIsCollapsed"
    [attr.aria-expanded]="!quotationIsCollapsed"
  >
    <div class="details-text">Details offerte</div>
    <button
      mat-icon-button
      class="arrow-button pull-right"
      style="margin-top: 5px"
    >
      <mat-icon svgIcon="arrow-up"></mat-icon>
    </button>
  </div>
  <div
    *ngIf="subproject.needsQuotation"
    class="upper-space"
    [collapse]="quotationIsCollapsed"
    [isAnimated]="!safari"
  >
    <div class="d-flex justify-content-between">
      <div>
        <div class="form-sub-title">Toegewezen aan</div>
        <mat-form-field appearance="outline" style="width: 100%">
          <mat-select
            matInput
            placeholder="Maak een keuze"
            required
            [(ngModel)]="subproject.quotationHandler"
            (ngModelChange)="quotationHandlerChange()"
            name="quotationHandler"
            [compareWith]="compareEntities"
          >
            <mat-option
              *ngFor="let option of quotationHandlerChoices"
              [value]="option"
            >
              <span *ngIf="option.user"
                >{{ option.user.firstName }} {{ option.user.lastName }}</span
              >
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <div class="left-space">
        <div class="form-sub-title">Deadline offerte</div>
        <mat-form-field class="first-form-field" appearance="outline">
          <input
            matInput
            [matDatepicker]="quotationByDatePicker"
            placeholder="Selecteer een datum"
            [(ngModel)]="subproject.quotationByDate"
            (ngModelChange)="quotationByDateChange()"
          />
          <mat-datepicker-toggle
            matSuffix
            [for]="quotationByDatePicker"
          ></mat-datepicker-toggle>
          <mat-datepicker #quotationByDatePicker></mat-datepicker>
        </mat-form-field>
      </div>

      <div align="right" style="flex: 1" class="left-space">
        <div class="form-sub-title">Belangrijk</div>
        <button
          [ngClass]="
            subproject.quotationImportant
              ? 'icon-button selected-icon-button'
              : 'icon-button non-selected-icon-button'
          "
          type="button"
          (click)="setImportantQuotation()"
          mat-button
          class="justify-items-center align-items-center"
        >
          <mat-icon>flag</mat-icon>
        </button>
      </div>
    </div>

    <textarea-input
      [title]="'Opmerkingen facturatie'"
      (answer)="setExtraInfoInvoice($event)"
      [initContent]="subproject.extraInfoInvoice"
    >
    </textarea-input>

    <textarea-input
      *ngIf="subproject.quotation != null"
      [title]="'Mededeling voor klant'"
      (answer)="setNoteForCustomer($event)"
      [initContent]="subproject.quotation.noteForCustomer"
      [sensitive]="true"
    >
    </textarea-input>

    <button
      class="button"
      type="button"
      mat-button
      (click)="openSendQuotationModal()"
    >
      {{ getSendQuotationLabel() }}
    </button>
    <ng-container *ngIf="subproject.quotation.registeredActions != null">
      <div class="registered-action-display under-space">
        <registered-action-display
          *ngFor="
            let registeredAction of subproject.quotation.registeredActions
          "
          [inputRegisteredAction]="registeredAction"
        ></registered-action-display>
      </div>
    </ng-container>

    <div *ngIf="subproject.needsQuotation">
      <div *ngIf="subproject.type === 'Repo'">
        <div *ngIf="getBaseProject().includeRepoInPrice">
          <p class="strong italics-text">Weghalen is inbegrepen in prijs</p>
          <br />
        </div>
      </div>
      <div class="details-margin">
        <adjustment-invoicing-container
          [project]="project"
          [inputSubProject]="subproject"
          [collapsed]="false"
          [embeddedInQuotation]="true"
          [invoiceSent]="invoiceSent"
          (outputInvoice)="save()"
        ></adjustment-invoicing-container>
      </div>
    </div>

    <yes-no
      [title]="'Offerte opgevolgd'"
      [value]="subproject.quotationFollowed"
      [neverShowExtraInstructions]="true"
      (answer)="setQuotationFollowed($event)"
    ></yes-no>
    <div class="d-flex">
      <yes-no
        [showExtraInstructionsOn]="'Nee'"
        [value]="subproject.quotation.approved"
        [yesValue]="'Goedgekeurd'"
        [noValue]="'Afgekeurd'"
        [nullIsFalse]="false"
        [inputText]="subproject.quotationComments"
        [extraInstructions]="'Geef hier de reden van afkeuring in'"
        (answer)="setQuotationApproved($event)"
        (answeredText)="setQuotationApprovalReasons($event)"
      ></yes-no>
      <div
        class="flexer quotation-approval-left font-italic"
        *ngIf="
          subproject.quotation.approved &&
          subproject.quotation.approvalRegistration
        "
      >
        - op
        {{ formatDate(subproject.quotation.approvalRegistration.date) }}
        door
        {{ subproject.quotation.approvalRegistration.by.firstName }}
        {{ subproject.quotation.approvalRegistration.by.lastName }}
      </div>
    </div>
  </div>
</mat-card>

<div
  class="form-title pending-checkbox-bottom-space"
  [ngClass]="subproject.needsQuotation ? 'pending-checkbox-upper-space' : ''"
>
  <div class="fixed-header-height">
    <checkbox
      [text]="'In behandeling'"
      [checked]="subproject.pending"
      [boldText]="true"
      (answer)="pendingChange($event)"
    ></checkbox>
  </div>
</div>

<!-- ONTWERP -->
<div *ngIf="subproject.type !== 'Repo'">
  <div class="form-title">
    <div class="d-flex fixed-header-height">
      <div class="form-title-text">Ontwerp</div>
      <div class="d-flex placers-space" *ngIf="subproject.adjustmentDesigner">
        <div
          class="employee-initials rounded-circle in-the-middle"
          [matTooltip]="getName(subproject.adjustmentDesigner)"
        >
          <span *ngIf="!subproject.adjustmentDesigner.user?.profilePicture">
            {{ getLetters(subproject.adjustmentDesigner) }}
          </span>
          <span *ngIf="subproject.adjustmentDesigner.user?.profilePicture">
            <img
              class="rounded-circle"
              width="30px"
              height="30px"
              [src]="
                '/api/assets/' +
                subproject.adjustmentDesigner.user.profilePicture.uuid +
                '/30'
              "
            />
          </span>
        </div>
      </div>
      <mat-icon
        *ngIf="subproject.designFinished"
        class="medium-icon placers-space align-with-title"
        svgIcon="check"
      ></mat-icon>
      <p
        *ngIf="subproject.currentDesignDate != null"
        class="placers-space align-date"
      >
        Ontwerp:
        {{ formatDate(subproject.currentDesignDate) }}
      </p>
      <p
        *ngIf="subproject.designApprovalRegistration != null"
        class="placers-space align-date"
      >
        Akkoord:
        {{ formatDate(subproject.designApprovalRegistration.date) }}
      </p>
    </div>
  </div>

  <yes-no
    [title]="'Ontwerp nodig'"
    [extraInstructions]="'Geef meer uitleg'"
    [nullIsFalse]="false"
    [alwaysShowExtraInstructions]="true"
    [value]="subproject.needsDesign"
    [inputText]="subproject.extraInfoDesign"
    [sensitiveText]="true"
    (answer)="needsDesign($event)"
    (answeredText)="needsDesignText($event)"
  ></yes-no>
  <mat-card
    *ngIf="subproject.needsDesign"
    class="top-card mat-elevation-z0 overflowHidden details-margin"
  >
    <div
      *ngIf="subproject.needsDesign"
      [class.collapsed]="designIsCollapsed"
      class="section-header d-flex overflowHidden clickable"
      (click)="designIsCollapsed = !designIsCollapsed"
      [attr.aria-expanded]="!designIsCollapsed"
    >
      <div class="details-text">Details ontwerp</div>
      <button
        mat-icon-button
        class="arrow-button pull-right"
        style="margin-top: 5px"
      >
        <mat-icon svgIcon="arrow-up"></mat-icon>
      </button>
    </div>
    <div
      *ngIf="subproject.needsDesign"
      class="upper-space"
      [collapse]="designIsCollapsed"
      [isAnimated]="!safari"
    >
      <div class="form-sub-title">Medewerker</div>

      <div class="d-flex">
        <mat-form-field class="" appearance="outline">
          <mat-select
            matInput
            placeholder="Maak een keuze"
            required
            [(ngModel)]="subproject.adjustmentDesigner"
            name="printworkHandler"
            (ngModelChange)="designerChange($event)"
            [compareWith]="compareEntities"
          >
            <mat-option *ngFor="let option of designerChoices" [value]="option">
              {{ option.user.firstName }} {{ option.user.lastName }}
            </mat-option>
          </mat-select>
        </mat-form-field>
        <div class="align-date-picker">
          <div class="form-sub-title">Ontwerp datum</div>
          <mat-form-field appearance="outline">
            <input
              matInput
              [matDatepicker]="picker"
              placeholder="Selecteer een datum"
              [(ngModel)]="subproject.currentDesignDate"
              name="designByDate"
              (ngModelChange)="designByDate($event)"
            />
            <mat-datepicker-toggle
              matSuffix
              [for]="picker"
            ></mat-datepicker-toggle>
            <mat-datepicker #picker></mat-datepicker>
          </mat-form-field>
        </div>

        <form class="form">
          <div class="d-flex align-time-budget-picker">
            <div class="timeInput">
              <div class="selector-label">Uren</div>
              <mat-form-field class="timeInput" appearance="outline">
                <mat-select
                  matInput
                  class="timeInputSelect"
                  required
                  [(ngModel)]="subproject.designerHourBudget"
                  name="designerHourBudget"
                  (ngModelChange)="setDesignHours()"
                  [compareWith]="compareNumbers"
                >
                  <mat-option
                    *ngFor="let option of hours"
                    [value]="option"
                    class="timeInputSelect"
                  >
                    {{ option }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>

            <div class="largeText">:</div>

            <div class="timeInput">
              <div class="selector-label">Minuten</div>
              <mat-form-field class="timeInput" appearance="outline">
                <mat-select
                  matInput
                  class="timeInputSelect"
                  required
                  [(ngModel)]="subproject.designerMinuteBudget"
                  name="designerMinuteBudget"
                  (ngModelChange)="setDesignMinutes()"
                  [compareWith]="compareNumbers"
                >
                  <mat-option
                    *ngFor="let option of minutes"
                    [value]="option"
                    class="timeInputSelect"
                  >
                    {{ option }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
          </div>
        </form>
      </div>

      <yes-no
        [title]="'Mag het Inpress logo toegevoegd worden?'"
        [neverShowExtraInstructions]="true"
        [extraInstructions]="''"
        [value]="subproject.inpressLogo"
        [inputText]="''"
        [nullIsFalse]="false"
        [nullable]="true"
        (answer)="inpressLogoChanged($event)"
      ></yes-no>

      <yes-no
        [title]="'Mag het Immoscoop logo toegevoegd worden?'"
        [neverShowExtraInstructions]="true"
        [extraInstructions]="''"
        [value]="subproject.immoscoopLogo"
        [inputText]="''"
        [nullIsFalse]="false"
        [nullable]="true"
        (answer)="immoscoopLogoChanged($event)"
      ></yes-no>

      <yes-no
        [title]="'Mag het Spotto logo toegevoegd worden?'"
        [neverShowExtraInstructions]="true"
        [extraInstructions]="''"
        [value]="subproject.spottoLogo"
        [inputText]="''"
        [nullIsFalse]="false"
        [nullable]="true"
        (answer)="spottoLogoChanged($event)"
      ></yes-no>

      <div class="under-space">
        <checkbox
          [title]="'Controle spelling'"
          [text]="'Ja, controle op typfouten werd uitgevoerd'"
          [checked]="subproject.spellCheck"
          (answer)="spellCheck($event)"
        >
        </checkbox>

        <logged-action-display
          *ngIf="subproject.spellCheckRegistration"
          [inputLoggedAction]="subproject.spellCheckRegistration"
        ></logged-action-display>
      </div>

      <file-picker
        [hideUpload]="false"
        [title]="'Ontwerp'"
        [subtitle]="'Voeg hier afbeeldingen van het ontwerp toe'"
        [inputProjectPlacement]="subproject.projectPlacement"
        [formSection]="'adjustmentDesign'"
      ></file-picker>

      <file-picker
        [hideUpload]="false"
        [title]="'Ontwerp + impressie'"
        [subtitle]="'Voeg hier afbeeldingen toe van het ontwerp + impressie'"
        [inputProjectPlacement]="subproject.projectPlacement"
        [formSection]="'adjustmentInternal'"
      ></file-picker>

      <textarea-input
        [title]="'Opvolging ontwerp'"
        [placeholder]="'Geef info over/duiding aan het ontwerp'"
        [minHeight]="200"
        [initContent]="this.subproject.designFollowUp"
        (answer)="designFollowUpChange($event)"
      ></textarea-input>

      <checkbox
        [text]="'Het ontwerp is verzonden naar de klant'"
        [checked]="subproject.designSentToCustomer"
        (answer)="designSentToCustomerChange($event)"
      ></checkbox>

      <logged-action-display
        *ngIf="subproject.designSentLog != null"
        [inputLoggedAction]="subproject.designSentLog"
      ></logged-action-display>

      <checkbox
        [text]="'Het ontwerp is goedgekeurd door de klant'"
        [checked]="subproject.designApproved"
        (answer)="designApproved($event)"
      ></checkbox>

      <logged-action-display
        *ngIf="subproject.designApprovalRegistration != null"
        [inputLoggedAction]="subproject.designApprovalRegistration"
      ></logged-action-display>

      <div class="upper-space">
        <dual-checkbox
          [title]="'Upload het design naar printer'"
          [checked]="[subproject.printByMutoh, subproject.printByAgfa]"
          [leftText]="'Ja, bestand verzonden naar Printer Mutoh'"
          [rightText]="'Ja, bestand verzonden naar Agfa'"
          (answer)="printByChange($event)"
        ></dual-checkbox>
      </div>

      <app-tiling
        [inputTilingAware]="subproject"
        (output)="save()"
      ></app-tiling>

      <file-picker
        [hideUpload]="false"
        [title]="'Design + tiling'"
        [subtitle]="'Voeg hier afbeeldingen toe van het ontwerp met tiling'"
        [inputProjectPlacement]="subproject.projectPlacement"
        [formSection]="'adjustmentTiling'"
      ></file-picker>

      <checkbox
        [text]="'Het ontwerp is afgewerkt'"
        [checked]="subproject.designFinished"
        [trueVerification]="designFinishedVerificationCallback"
        (answer)="designFinishedChange($event)"
      ></checkbox>

      <logged-action-display
        *ngIf="subproject.designFinishedLog != null"
        [inputLoggedAction]="subproject.designFinishedLog"
      ></logged-action-display>
    </div>
  </mat-card>
</div>

<!-- PRINTWERK -->
<div *ngIf="subproject.type !== 'Repo'">
  <div class="form-title">
    <div class="d-flex fixed-header-height">
      <div class="form-title-text">Printwerk</div>
      <div
        class="d-flex placers-space"
        *ngIf="subproject.adjustmentPrintworkHandler"
      >
        <div
          class="employee-initials rounded-circle in-the-middle"
          [matTooltip]="getName(subproject.adjustmentPrintworkHandler)"
        >
          <span
            *ngIf="!subproject.adjustmentPrintworkHandler.user?.profilePicture"
          >
            {{ getLetters(subproject.adjustmentPrintworkHandler) }}
          </span>
          <span
            *ngIf="subproject.adjustmentPrintworkHandler.user?.profilePicture"
          >
            <img
              class="rounded-circle"
              width="30px"
              height="30px"
              [src]="
                '/api/assets/' +
                subproject.adjustmentPrintworkHandler.user.profilePicture.uuid +
                '/30'
              "
            />
          </span>
        </div>
      </div>
      <mat-icon
        *ngIf="subproject.printWorkReady"
        class="medium-icon placers-space align-with-title"
        svgIcon="check"
      ></mat-icon>
      <p
        *ngIf="subproject.printWorkReadyRegistration?.date != null"
        class="placers-space align-date"
      >
        Afgewerkt:
        {{ formatDate(subproject.printWorkReadyRegistration.date) }}
      </p>
    </div>
  </div>

  <yes-no
    [title]="'Printwerk nodig'"
    [value]="subproject.needPrintwork"
    [alwaysShowExtraInstructions]="true"
    [extraInstructions]="
      'Geef extra informatie (bv. externe leveranciers, ...)'
    "
    [inputText]="subproject.printworkExtraInfo"
    [nullIsFalse]="false"
    [nullable]="true"
    (answer)="printWork($event)"
    (answeredText)="printworkExtraInfoChange($event)"
  ></yes-no>

  <mat-card
    *ngIf="subproject.needPrintwork"
    class="top-card mat-elevation-z0 overflowHidden details-margin"
  >
    <div
      *ngIf="subproject.needPrintwork"
      [class.collapsed]="printworkIsCollapsed"
      class="section-header d-flex overflowHidden clickable"
      (click)="printworkIsCollapsed = !printworkIsCollapsed"
      [attr.aria-expanded]="!printworkIsCollapsed"
    >
      <div class="details-text">Details printwerk</div>
      <button
        mat-icon-button
        class="arrow-button pull-right"
        style="margin-top: 5px"
      >
        <mat-icon svgIcon="arrow-up"></mat-icon>
      </button>
    </div>
    <div
      *ngIf="subproject.needPrintwork"
      class="upper-space"
      [collapse]="printworkIsCollapsed"
      [isAnimated]="!safari"
    >
      <div class="title">Materiaal ontwerp</div>
      <p class="preserve-line-break">{{ displayDesignMaterial() }}</p>

      <div class="title">Afmetingen ontwerp</div>
      <p class="preserve-line-break">{{ displayDesignSize() }}</p>

      <div class="title">Aantal ontwerp</div>
      <p>{{ displayAmountDesign() }}</p>

      <div class="form-sub-title">Medewerker</div>

      <mat-form-field class="" appearance="outline">
        <mat-select
          matInput
          placeholder="Maak een keuze"
          required
          [(ngModel)]="subproject.adjustmentPrintworkHandler"
          name="printworkHandler"
          (ngModelChange)="printworkHandlerChange($event)"
          [compareWith]="compareEntities"
        >
          <mat-option
            *ngFor="let option of printworkHandlerChoices"
            [value]="option"
          >
            {{ option.user.firstName }} {{ option.user.lastName }}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <textarea-input
        [title]="'Opvolging printwerk'"
        [minHeight]="200"
        [initContent]="this.subproject.printworkFollowUp"
        (answer)="printworkFollowUpChange($event)"
      ></textarea-input>

      <div class="font-weight-bold">Datum printwerk</div>

      <mat-form-field appearance="outline">
        <input
          matInput
          [matDatepicker]="printPicker"
          placeholder="Selecteer een datum"
          [(ngModel)]="subproject.currentPrintDate"
          name="printByDate"
          (ngModelChange)="designByDate($event)"
        />
        <mat-datepicker-toggle
          matSuffix
          [for]="printPicker"
        ></mat-datepicker-toggle>
        <mat-datepicker #printPicker></mat-datepicker>
      </mat-form-field>

      <checkbox
        [title]="'Printwerk klaar'"
        [text]="'Printwerk is afgerond'"
        [checked]="subproject.printWorkReady"
        (answer)="printworkReady($event)"
      ></checkbox>

      <logged-action-display
        *ngIf="subproject.printWorkReadyRegistration != null"
        [inputLoggedAction]="subproject.printWorkReadyRegistration"
      ></logged-action-display>
    </div>
  </mat-card>
</div>

<!-- AFWERKING -->
<div *ngIf="subproject.type !== 'Repo'">
  <div class="form-title">
    <div class="d-flex fixed-header-height">
      <div class="form-title-text">Afwerking</div>
      <div class="d-flex placers-space" *ngIf="subproject.adjustmentFinisher">
        <div
          class="employee-initials rounded-circle in-the-middle"
          [matTooltip]="getName(subproject.adjustmentFinisher)"
        >
          <span *ngIf="!subproject.adjustmentFinisher.user?.profilePicture">
            {{ getLetters(subproject.adjustmentFinisher) }}
          </span>
          <span *ngIf="subproject.adjustmentFinisher.user?.profilePicture">
            <img
              class="rounded-circle"
              width="30px"
              height="30px"
              [src]="
                '/api/assets/' +
                subproject.adjustmentFinisher.user.profilePicture.uuid +
                '/30'
              "
            />
          </span>
        </div>
      </div>
      <mat-icon
        *ngIf="subproject.finishReady"
        class="medium-icon placers-space align-with-title"
        svgIcon="check"
      ></mat-icon>
      <p
        *ngIf="subproject.finishReadyRegistration?.date != null"
        class="placers-space align-date"
      >
        Afgewerkt:
        {{ formatDate(subproject.finishReadyRegistration.date) }}
      </p>
    </div>
  </div>

  <yes-no
    [title]="'Afwerking nodig'"
    [value]="subproject.needFinish"
    [alwaysShowExtraInstructions]="true"
    [extraInstructions]="
      'Geef extra informatie (bv. externe leveranciers, ...)'
    "
    [inputText]="subproject.finishDescription"
    [nullIsFalse]="false"
    [nullable]="true"
    (answer)="finish($event)"
    (answeredText)="finishDescriptionChange($event)"
  ></yes-no>
  <mat-card
    *ngIf="subproject.needFinish"
    class="top-card mat-elevation-z0 overflowHidden details-margin"
  >
    <div
      *ngIf="subproject.needFinish"
      [class.collapsed]="finishIsCollapsed"
      class="section-header d-flex overflowHidden clickable"
      (click)="finishIsCollapsed = !finishIsCollapsed"
      [attr.aria-expanded]="!finishIsCollapsed"
    >
      <div class="details-text">Details afwerking</div>
      <button
        mat-icon-button
        class="arrow-button pull-right"
        style="margin-top: 5px"
      >
        <mat-icon svgIcon="arrow-up"></mat-icon>
      </button>
    </div>
    <div
      *ngIf="subproject.needFinish"
      class="upper-space"
      [collapse]="finishIsCollapsed"
      [isAnimated]="!safari"
    >
      <div class="title">Materiaal ontwerp</div>
      <p class="preserve-line-break">{{ displayDesignMaterial() }}</p>

      <div class="title">Afmetingen ontwerp</div>
      <p class="preserve-line-break">{{ displayDesignSize() }}</p>

      <div class="title">Aantal ontwerp</div>
      <p>{{ displayAmountDesign() }}</p>

      <div class="form-sub-title">Medewerker</div>

      <mat-form-field class="" appearance="outline">
        <mat-select
          matInput
          placeholder="Maak een keuze"
          required
          [(ngModel)]="subproject.adjustmentFinisher"
          name="finisher"
          (ngModelChange)="finisherChange($event)"
          [compareWith]="compareEntities"
        >
          <mat-option *ngFor="let option of finisherChoices" [value]="option">
            {{ option.user.firstName }} {{ option.user.lastName }}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <textarea-input
        [title]="'Opvolging afwerking'"
        [minHeight]="200"
        [initContent]="this.subproject.finishFollowUp"
        (answer)="finishFollowUpChange($event)"
      ></textarea-input>

      <div class="font-weight-bold">Datum afwerking</div>
      <mat-form-field appearance="outline">
        <input
          matInput
          [matDatepicker]="finishPicker"
          placeholder="Selecteer een datum"
          [(ngModel)]="subproject.currentFinishDate"
          name="finishByDate"
          (ngModelChange)="designByDate($event)"
        />
        <mat-datepicker-toggle
          matSuffix
          [for]="finishPicker"
        ></mat-datepicker-toggle>
        <mat-datepicker #finishPicker></mat-datepicker>
      </mat-form-field>

      <checkbox
        [title]="'Afwerking klaar'"
        [text]="'Afwerking is afgerond'"
        [checked]="subproject.finishReady"
        (answer)="finishReady($event)"
      ></checkbox>

      <logged-action-display
        *ngIf="subproject.finishReadyRegistration != null"
        [inputLoggedAction]="subproject.finishReadyRegistration"
      ></logged-action-display>
    </div>
  </mat-card>
</div>

<!-- LOCATIEBEPALING -->
<div *ngIf="subproject.projectPlacement != null" class="form-title">
  <div class="d-flex fixed-header-height">
    <div class="form-title-text">Locatiebepaling</div>
    <mat-icon
      *ngIf="
        subproject.projectPlacement?.doLocationVerification &&
        subproject.projectPlacement?.locationVerificationCheckedByExpert
      "
      class="medium-icon placers-space align-with-title"
      svgIcon="check"
    ></mat-icon>
  </div>
</div>
<div *ngIf="subproject.projectPlacement != null">
  <yes-no
    [title]="'Locatiebepaling nodig'"
    [value]="subproject.projectPlacement.doLocationVerification"
    [neverShowExtraInstructions]="true"
    [nullIsFalse]="false"
    (answer)="doLocationVerificationChange($event)"
  ></yes-no>
  <div class="bottom-space">
    <textarea-input
      *ngIf="subproject.projectPlacement.doLocationVerification"
      [placeholder]="''"
      [initContent]="subproject.projectPlacement.locationVerificationExtraInfo"
      (answer)="locationVerificationExtraInfoChange($event)"
    >
    </textarea-input>
    <checkbox
      *ngIf="subproject.projectPlacement.doLocationVerification"
      class="bottom-space"
      [text]="'Locatiebepaling volledig in orde'"
      [checked]="
        subproject.projectPlacement.locationVerificationCheckedByExpert
      "
      (answer)="locationVerificationCheckedByExpertChange($event)"
    ></checkbox>
    <logged-action-display
      *ngIf="
        subproject.projectPlacement
          .locationVerificationCheckedByExpertRegistration != null
      "
      [inputLoggedAction]="
        subproject.projectPlacement
          .locationVerificationCheckedByExpertRegistration
      "
    ></logged-action-display>
  </div>
</div>

<!-- INSTALLATEUR -->
<div class="form-title">
  <div class="d-flex fixed-header-height">
    <div class="form-title-text">Installateur</div>
    <div
      class="d-flex placers-space"
      *ngIf="subproject.projectPlacement?.placers?.length > 0"
    >
      <div
        *ngFor="
          let placer of subproject.projectPlacement.placers;
          trackBy: trackById
        "
        class="employee-initials rounded-circle in-the-middle"
        [matTooltip]="getName(placer)"
      >
        <span *ngIf="!placer.user?.profilePicture">
          {{ getLetters(placer) }}
        </span>
        <span *ngIf="placer.user?.profilePicture">
          <img
            class="rounded-circle"
            width="30px"
            height="30px"
            [src]="'/api/assets/' + placer.user.profilePicture.uuid + '/30'"
          />
        </span>
      </div>
    </div>
    <mat-icon
      *ngIf="subproject.projectPlacement?.placementDone"
      class="medium-icon placers-space align-with-title"
      svgIcon="check"
    ></mat-icon>
    <p
      *ngIf="subproject.currentExecutionDate != null"
      class="placers-space align-date"
    >
      Uitgevoerd:
      {{ formatDate(subproject.currentExecutionDate) }}
    </p>
  </div>
</div>
<yes-no
  [title]="'Installatie nodig'"
  [value]="subproject.withPlacement"
  [alwaysShowExtraInstructions]="true"
  [extraInstructions]="'Geef extra informatie (bv. externe leveranciers, ...)'"
  [inputText]="
    subproject.withPlacementNotes == null
      ? getBaseProjectExtraInfoPlacement()
      : subproject.withPlacementNotes
  "
  [sensitiveText]="true"
  [nullIsFalse]="false"
  (answer)="withPlacementChange($event)"
  (answeredText)="withPlacementNotesChange($event)"
></yes-no>
<div class="details-margin">
  <checkbox
    *ngIf="
      subproject.type !== 'Repo' &&
      subproject.withPlacement === false &&
      subproject.pickup != null
    "
    [text]="'Klaar voor afhaling'"
    [checked]="subproject.pickup.ready"
    (answer)="pickupReadyChange($event)"
  ></checkbox>
</div>
<mat-card
  *ngIf="subproject.withPlacement"
  class="top-card mat-elevation-z0 overflowHidden details-margin"
>
  <div
    *ngIf="subproject.withPlacement"
    [class.collapsed]="placementIsCollapsed"
    class="section-header d-flex overflowHidden clickable"
    (click)="placementIsCollapsed = !placementIsCollapsed"
    [attr.aria-expanded]="!placementIsCollapsed"
  >
    <div class="details-text">Details installateur</div>
    <button
      mat-icon-button
      class="arrow-button pull-right"
      style="margin-top: 5px"
    >
      <mat-icon svgIcon="arrow-up"></mat-icon>
    </button>
  </div>
  <div
    *ngIf="subproject.withPlacement"
    class="upper-space"
    [collapse]="placementIsCollapsed"
    [isAnimated]="!safari"
  >
    <div class="title">Verdieping</div>
    <p>{{ getBaseProjectPlacementFloor() }}</p>

    <div class="title">Ladder/stelling/hoogtewerker basisproject</div>
    <p>{{ getBaseProjectHeightEquipment() }}</p>

    <div *ngIf="subproject.type !== 'Repo'">
      <div class="title">Materiaal ontwerp</div>
      <p class="preserve-line-break">{{ displayDesignMaterial() }}</p>

      <div class="title">Afmetingen ontwerp</div>
      <p class="preserve-line-break">{{ displayDesignSize() }}</p>

      <div class="title">Aantal ontwerp</div>
      <p>{{ displayAmountDesign() }}</p>
    </div>

    <yes-no
      [title]="'Hoogwerker'"
      [value]="subproject.extraHoogwerker"
      [nullable]="true"
      [nullIsFalse]="false"
      [inputText]="subproject.extraHoogwerkerDescription"
      [done]="subproject.extraHoogwerkerDone"
      [extraInstructions]="'Type hoogwerker, ...'"
      (answer)="extraHoogwerkerChange($event)"
      (answeredText)="extraHoogwerkerTextChange($event)"
      (doneAnswered)="extraHoogwerkerDoneChange($event)"
    >
    </yes-no>

    <div
      *ngIf="subproject.extraHoogwerker"
      class="d-flex external-supplier-employee-date"
    >
      <div>
        <div class="form-sub-title">Medewerker</div>

        <mat-form-field class="" appearance="outline">
          <mat-select
            matInput
            placeholder="Maak een keuze"
            name="hoogwerkerEmployee"
            required
            [(ngModel)]="subproject.extraHoogwerkerEmployee"
            (ngModelChange)="extraHoogwerkerEmployeeChange()"
            [compareWith]="compareEntities"
          >
            <mat-option
              *ngFor="let option of externalSupplierEmployeeChoices"
              [value]="option"
            >
              {{ option.user.firstName }} {{ option.user.lastName }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <div class="left-space">
        <div class="form-sub-title">Deadline</div>
        <mat-form-field appearance="outline">
          <input
            #extraHoogwerkerDeadlineInput
            matInput
            [matDatepicker]="extraHoogwerkerDeadlinePicker"
            placeholder="Selecteer een datum"
            [value]="subproject.extraHoogwerkerDeadline"
            (dateChange)="extraHoogwerkerDeadlineChange($event)"
          />
          <mat-datepicker-toggle
            matSuffix
            [for]="extraHoogwerkerDeadlinePicker"
          ></mat-datepicker-toggle>
          <mat-datepicker #extraHoogwerkerDeadlinePicker></mat-datepicker>
        </mat-form-field>
      </div>
    </div>

    <yes-no
      [title]="'Parkeerverbod'"
      [value]="subproject.parkingBan"
      [nullable]="true"
      [nullIsFalse]="false"
      [inputText]="subproject.extraInfoParkingBan"
      [done]="subproject.parkingBanDone"
      (answer)="parkingBanChange($event)"
      (answeredText)="extraInfoParkingBanChange($event)"
      (doneAnswered)="parkingBanDoneChange($event)"
    ></yes-no>

    <div
      *ngIf="subproject.parkingBan"
      class="d-flex external-supplier-employee-date"
    >
      <div>
        <div class="form-sub-title">Medewerker</div>

        <mat-form-field class="" appearance="outline">
          <mat-select
            matInput
            placeholder="Maak een keuze"
            name="parkingBanEmployee"
            required
            [(ngModel)]="subproject.parkingBanEmployee"
            (ngModelChange)="parkingBanEmployeeChange()"
            [compareWith]="compareEntities"
          >
            <mat-option
              *ngFor="let option of externalSupplierEmployeeChoices"
              [value]="option"
            >
              {{ option.user.firstName }} {{ option.user.lastName }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <div class="left-space">
        <div class="form-sub-title">Deadline</div>
        <mat-form-field appearance="outline">
          <input
            #parkingBanDeadlineInput
            matInput
            [matDatepicker]="parkingBanDeadlinePicker"
            placeholder="Selecteer een datum"
            [value]="subproject.parkingBanDeadline"
            (dateChange)="parkingBanDeadlineChange($event)"
          />
          <mat-datepicker-toggle
            matSuffix
            [for]="parkingBanDeadlinePicker"
          ></mat-datepicker-toggle>
          <mat-datepicker #parkingBanDeadlinePicker></mat-datepicker>
        </mat-form-field>
      </div>
    </div>

    <yes-no
      [title]="'Extra leverancier nodig'"
      [value]="subproject.needExtraSupplier"
      [nullable]="true"
      [nullIsFalse]="false"
      [done]="subproject.needExtraSupplierDone"
      [inputText]="subproject.extraInfoNeedExtraSupplier"
      [extraInstructions]="'Geef meer informatie aub'"
      (answer)="needExtraSupplierChange($event)"
      (answeredText)="extraInfoNeedExtraSupplierChange($event)"
      (doneAnswered)="needExtraSupplierDoneChange($event)"
    >
    </yes-no>

    <div
      *ngIf="subproject.needExtraSupplier"
      class="d-flex external-supplier-employee-date"
    >
      <div>
        <div class="form-sub-title">Medewerker</div>

        <mat-form-field class="" appearance="outline">
          <mat-select
            matInput
            placeholder="Maak een keuze"
            name="extraSupplierEmployee"
            required
            [(ngModel)]="subproject.extraSupplierEmployee"
            (ngModelChange)="extraSupplierEmployeeChange()"
            [compareWith]="compareEntities"
          >
            <mat-option
              *ngFor="let option of externalSupplierEmployeeChoices"
              [value]="option"
            >
              {{ option.user.firstName }} {{ option.user.lastName }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <div class="left-space">
        <div class="form-sub-title">Deadline</div>
        <mat-form-field appearance="outline">
          <input
            #extraSupplierDeadlineInput
            matInput
            [matDatepicker]="extraSupplierDeadlinePicker"
            placeholder="Selecteer een datum"
            [value]="subproject.extraSupplierDeadline"
            (dateChange)="extraSupplierDeadlineChange($event)"
          />
          <mat-datepicker-toggle
            matSuffix
            [for]="extraSupplierDeadlinePicker"
          ></mat-datepicker-toggle>
          <mat-datepicker #extraSupplierDeadlinePicker></mat-datepicker>
        </mat-form-field>
      </div>
    </div>

    <yes-no
      [title]="'Extra materialen nodig'"
      [value]="subproject.needExtraMaterials"
      [nullable]="true"
      [nullIsFalse]="false"
      [done]="subproject.needExtraMaterialsDone"
      [inputText]="subproject.extraInfoNeedExtraMaterials"
      [extraInstructions]="'Geef meer informatie aub'"
      (answer)="needExtraMaterialsChange($event)"
      (answeredText)="extraInfoNeedExtraMaterialsChange($event)"
      (doneAnswered)="needExtraMaterialsDoneChange($event)"
    >
    </yes-no>

    <div
      *ngIf="subproject.needExtraMaterials"
      class="d-flex external-supplier-employee-date"
    >
      <div>
        <div class="form-sub-title">Medewerker</div>

        <mat-form-field class="" appearance="outline">
          <mat-select
            matInput
            placeholder="Maak een keuze"
            name="extraMaterialsEmployee"
            required
            [(ngModel)]="subproject.extraMaterialsEmployee"
            (ngModelChange)="extraMaterialsEmployeeChange()"
            [compareWith]="compareEntities"
          >
            <mat-option
              *ngFor="let option of externalSupplierEmployeeChoices"
              [value]="option"
            >
              {{ option.user.firstName }} {{ option.user.lastName }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <div class="left-space">
        <div class="form-sub-title">Deadline</div>
        <mat-form-field appearance="outline">
          <input
            #extraMaterialsDeadlineInput
            matInput
            [matDatepicker]="extraMaterialsDeadlinePicker"
            placeholder="Selecteer een datum"
            [value]="subproject.extraMaterialsDeadline"
            (dateChange)="extraMaterialsDeadlineChange($event)"
          />
          <mat-datepicker-toggle
            matSuffix
            [for]="extraMaterialsDeadlinePicker"
          ></mat-datepicker-toggle>
          <mat-datepicker #extraMaterialsDeadlinePicker></mat-datepicker>
        </mat-form-field>
      </div>
    </div>

    <div *ngIf="subproject.projectPlacement != null">
      <div class="d-flex">
        <div>
          <div class="form-sub-title">Installateur(s)</div>

          <mat-form-field class="" appearance="outline">
            <mat-select
              matInput
              multiple
              placeholder="Maak een keuze"
              required
              [(ngModel)]="subproject.projectPlacement.placers"
              name="placer"
              (ngModelChange)="placerChange($event)"
              [compareWith]="compareEntities"
            >
              <mat-option *ngFor="let option of placerChoices" [value]="option">
                {{ option.user.firstName }} {{ option.user.lastName }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div class="flex-grow-1">
          <div class="form-field form-sub-title">Gekozen installateur(s)</div>

          <p
            class="title-top form-field"
            *ngIf="
              subproject.projectPlacement.placers == null ||
              subproject.projectPlacement.placers.length === 0
            "
          >
            Geen medewerkers gekozen
          </p>
          <ul
            class="form-field placer-list"
            *ngIf="
              subproject.projectPlacement.placers != null &&
              subproject.projectPlacement.placers.length > 0
            "
          >
            <li *ngFor="let placer of subproject.projectPlacement.placers">
              {{ placer.user.firstName }} {{ placer.user.lastName }}
            </li>
          </ul>
        </div>
      </div>

      <div class="d-flex">
        <div>
          <div class="font-weight-bold">
            Datum {{ subproject.type === 'Repo' ? 'weghalen' : 'plaatsing' }}
          </div>
          <mat-form-field appearance="outline">
            <input
              #confirmedPlacementDateInput
              matInput
              [matDatepicker]="confirmedPlacementPicker"
              placeholder="Selecteer een datum"
              [value]="subproject.currentConfirmedPlacementDate"
              [disabled]="
                subproject.projectPlacement.currentPlacementDateConfirmed
              "
              name="confirmedPlacementDateDate"
              (dateChange)="currentConfirmedPlacementDateChange($event)"
            />
            <mat-datepicker-toggle
              matSuffix
              [for]="confirmedPlacementPicker"
            ></mat-datepicker-toggle>
            <mat-datepicker #confirmedPlacementPicker></mat-datepicker>
          </mat-form-field>
        </div>
        <div class="align-placement-date-confirmed-checkbox">
          <checkbox
            [checked]="
              subproject.projectPlacement.currentPlacementDateConfirmed
            "
            [text]="'Datum vastzetten'"
            [isDisabled]="subproject.currentConfirmedPlacementDate == null"
            (answer)="currentPlacementDateConfirmedChange($event)"
          ></checkbox>
        </div>
      </div>

      <textarea-input
        *ngIf="
          subproject.type !== 'Repo' && subproject.projectPlacement != null
        "
        [title]="'Hoe plaatsen'"
        [placeholder]="'Geef hier instructies voor de plaatsing'"
        (answer)="placeInstructionsChanged($event)"
        [initContent]="subproject.projectPlacement.placeInstructions"
      >
      </textarea-input>

      <ng-container
        *ngIf="
          subproject.type === 'SoldRented' &&
          subproject.projectPlacement != null
        "
      >
        <div class="title">Afstand vanop de grond tot bovenkant sticker</div>
        <div class="first-form-field">
          <mat-form-field appearance="outline">
            <mat-label>Meter</mat-label>
            <input
              type="number"
              placeholder="Meter"
              matInput
              [ngModelOptions]="{ standalone: true }"
              [(ngModel)]="
                subproject.projectPlacement.soldRentedStickerWorkHeight
              "
              (ngModelChange)="soldRentedStickerWorkHeightChange($event)"
              required
            />
          </mat-form-field>
        </div>
      </ng-container>

      <ng-container *ngIf="subproject.projectPlacement != null">
        <div class="title">Ladder/stelling/hoogwerker</div>
        <mat-form-field class="first-form-field" appearance="outline">
          <mat-select
            matInput
            placeholder="Kies gereedschap"
            [(ngModel)]="subproject.projectPlacement.heightEquipment"
            (ngModelChange)="heightEquipmentChange()"
            [ngModelOptions]="{ standalone: true }"
            [compareWith]="compareEnums"
            required
          >
            <mat-option
              *ngFor="let equipment of heightEquipmentOptions"
              [value]="equipment"
            >
              {{ equipment.name }}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <yes-no
          [title]="'Zijn er obstakels'"
          [showExtraInstructionsOn]="'Ja'"
          [nullIsFalse]="false"
          [nullable]="true"
          [value]="subproject.projectPlacement.obstaclesPresent"
          [inputText]="subproject.projectPlacement.obstaclesInfo"
          [extraInstructions]="'Geef meer informatie aub'"
          (answer)="obstaclesPresentChange($event)"
          (answeredText)="obstaclesInfoTextChange($event)"
        >
        </yes-no>
      </ng-container>

      <div class="form-sub-title">Voorziene tijd installateur</div>

      <div class="d-flex">
        <div class="timeInput">
          <div class="selector-label">Uren</div>
          <mat-form-field class="timeInput" appearance="outline">
            <mat-select
              matInput
              class="timeInputSelect"
              required
              [(ngModel)]="subproject.projectPlacement.installerHourBudget"
              name="installerHourBudget"
              (ngModelChange)="setHours()"
              [compareWith]="compareNumbers"
            >
              <mat-option
                *ngFor="let option of hours"
                [value]="option"
                class="timeInputSelect"
              >
                {{ option }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <div class="largeText">:</div>

        <div class="timeInput">
          <div class="selector-label">Minuten</div>
          <mat-form-field class="timeInput" appearance="outline">
            <mat-select
              matInput
              class="timeInputSelect"
              required
              [(ngModel)]="subproject.projectPlacement.installerMinuteBudget"
              name="installerMinuteBudget"
              (ngModelChange)="setMinutes()"
              [compareWith]="compareNumbers"
            >
              <mat-option
                *ngFor="let option of minutes"
                [value]="option"
                class="timeInputSelect"
              >
                {{ option }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>

      <yes-no
        [title]="'Uitgevoerd'"
        [yesValue]="getFormDisplayNameUpperCase() + ' werd uitgevoerd'"
        [noValue]="getFormDisplayNameUpperCase() + ' werd niet uitgevoerd'"
        [showExtraInstructionsOn]="
          getFormDisplayNameUpperCase() + ' werd niet uitgevoerd'
        "
        [value]="subproject.projectPlacement.placementDone"
        [inputText]="subproject.projectPlacement.placementDoneExtraInfo"
        [extraInstructions]="'Reden niet uitgevoerd'"
        [nullIsFalse]="false"
        (answer)="placementDoneChange($event)"
        (answeredText)="placementDoneExtraInfoChange($event)"
      >
      </yes-no>

      <logged-action-display
        *ngIf="subproject.projectPlacement.placementDoneRegistration != null"
        [inputLoggedAction]="
          subproject.projectPlacement.placementDoneRegistration
        "
      ></logged-action-display>
      <ng-container
        *ngIf="subproject.projectPlacement.registeredActions?.length > 0"
      >
        <registered-action-display
          *ngFor="
            let registeredAction of subproject.projectPlacement
              .registeredActions;
            trackBy: trackBy
          "
          [inputRegisteredAction]="registeredAction"
        ></registered-action-display>
      </ng-container>

      <file-picker
        *ngIf="subproject.projectPlacement.placementDone"
        [hideUpload]="false"
        [title]="'Plaatsingsfoto'"
        [subtitle]="'Voeg hier afbeeldingen toe van de plaatsing'"
        [inputProjectPlacement]="subproject.projectPlacement"
        [formSection]="'adjustmentPlacementSuccess'"
      ></file-picker>

      <file-picker
        *ngIf="subproject.projectPlacement.placementDone === false"
        [hideUpload]="false"
        [title]="'Plaatsing niet uitgevoerd'"
        [subtitle]="
          'Voeg hier afbeeldingen toe die meer duiding kunnen geven bij het niet plaatsen'
        "
        [inputProjectPlacement]="subproject.projectPlacement"
        [formSection]="'adjustmentPlacementFailed'"
      ></file-picker>

      <textarea-input
        [title]="'Feedback installateur'"
        [minHeight]="200"
        [initContent]="this.subproject.projectPlacement.placerFeedback"
        (answer)="placerFeedbackChange($event)"
      ></textarea-input>

      <div *ngIf="displayTotalExecutionTime && totalExecutionTime?.length > 0">
        <span class="strong">Totale uitvoeringstijd: </span
        >{{ totalExecutionTime }}
      </div>
    </div>
  </div>
</mat-card>

<!-- FACTUUR -->
<div class="form-title">
  <div class="d-flex fixed-header-height">
    <div class="form-title-text">Factuur</div>
    <div class="d-flex placers-space" *ngIf="subproject.invoiceHandler">
      <div
        class="employee-initials rounded-circle in-the-middle"
        [matTooltip]="getName(subproject.invoiceHandler)"
      >
        <span *ngIf="!subproject.invoiceHandler.user?.profilePicture">
          {{ getLetters(subproject.invoiceHandler) }}
        </span>
        <span *ngIf="subproject.invoiceHandler.user?.profilePicture">
          <img
            class="rounded-circle"
            width="30px"
            height="30px"
            [src]="
              '/api/assets/' +
              subproject.invoiceHandler.user.profilePicture.uuid +
              '/30'
            "
          />
        </span>
      </div>
    </div>
    <mat-icon
      *ngIf="atLeastOneInvoiceSent()"
      class="medium-icon placers-space align-with-title"
      svgIcon="check"
    ></mat-icon>
    <p *ngIf="atLeastOneInvoiceSent()" class="placers-space align-date">
      Verstuurd:
      {{ formatDate(getFirstSentInvoice().sentDate) }}
      <span
        *ngFor="
          let invoice of subproject.projectInvoices | sentInvoiceFilter;
          let first = first;
          let last = last
        "
        [ngClass]="first ? 'placers-space' : ''"
      >
        <a
          href="https://app.teamleader.eu/invoice_detail.php?id={{
            invoice.teamleaderId
          }}"
          target="_blank"
          >{{ getLinkText(invoice) }}</a
        >{{ last ? '' : ', ' }}
      </span>
    </p>
  </div>
</div>
<yes-no
  [title]="'Factuur nodig'"
  [value]="subproject.needsInvoice"
  [alwaysShowExtraInstructions]="true"
  [extraInstructions]="'Geef extra informatie'"
  [inputText]="subproject.invoiceNotes"
  [nullIsFalse]="false"
  (answer)="needsInvoiceChange($event)"
  (answeredText)="invoiceNotesChange($event)"
></yes-no>
<div *ngIf="subproject.needsInvoice">
  <div class="details-margin" *ngIf="subproject.type === 'Repo'">
    <div *ngIf="getBaseProject().includeRepoInPrice">
      <p class="strong italics-text">Weghalen is inbegrepen in prijs</p>
      <br />
    </div>
  </div>
  <div class="details-margin">
    <adjustment-invoicing-container
      [project]="project"
      [inputSubProject]="subproject"
      [collapsed]="invoicingIsCollapsed"
      [invoiceSent]="invoiceSent"
      (outputInvoice)="save()"
    ></adjustment-invoicing-container>
  </div>
</div>
